// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1Crj3","imageUploader":"EGiftCard_imageUploader__1rMtR"};